<template>
  <div class="dashboard-container">
    <a-row :gutter="20" class="dashboard">
      <a-col :span="isDesktop ? 16 : 24">
        <a-card :title="$t('cardTitle.howToSetupYourChurchProfile')" class="style1 text-center">
          <div class="quotes-wrapper">
            <span class="ant-card-head-title text-center" style="white-space: break-spaces"> <q> For we cannot stop speaking about what we have seen and heard.</q> Acts 4:20 </span>
          </div>

          <div v-if="isFreeEvangelism" class="dashbaord-video">
            <iframe :src="instructionVideo('FREE_PASTOR_MAIN_DASHBOARD_VIDEO')" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
          </div>
          <div v-if="!isFreeEvangelism" class="dashbaord-video">
            <iframe :src="instructionVideo('P_MAIN_DASHBOARD_LINK')" width="640" height="361" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
          </div>
        </a-card>
        <ActionBox v-if="!isFreeEvangelism" />
        <a-card :title="pageDescription.title">
          <p>
            <strong v-text="pageDescription.es_title"></strong>
          </p>
          <div class="page-description-content" v-html="pageDescription.content"></div>
        </a-card>
        <!-- <a-card :title="$t('cardTitle.recentUpdate')">
          <p>
            {{ $t('page.dashboard.recentUpdate.para1') }}
            <a href="https://www.truelife.org/pages/terms-of-use">{{ $t('page.dashboard.recentUpdate.link') }}.</a>
          </p>
        </a-card> -->
      </a-col>
      <a-col :span="isDesktop ? 8 : 24">
        <a-card :title="$t('cardTitle.accountPaymentDate')" v-if="nextPayment">
          <p>
            {{ $t('page.dashboard.accountPaymentDate.para1') }}:
            <strong>{{ nextPayment }}</strong>
          </p>
          <p>
            <a-button type="primary" @click="openLink('account')">
              <span> <a-icon type="user" />&nbsp;{{ $t('button.accountDetails') }} </span>
            </a-button>
          </p>
        </a-card>
        <a-collapse>
          <a-collapse-panel key="1" :header="$t('cardTitle.churchMembershipInformation')">
            <div v-if="getPlan" class="text-center">
              <p>
                Membership Type:
                <strong>{{ getPlan.title }}</strong>
              </p>
              <p>
                Subscription:
                <strong>{{ getPlan.subscription }}</strong>
              </p>
              <p>
                Status:
                <a
                  @click="
                    e => {
                      showResubscribeModal = getPlan.status !== 'active';
                    }
                  "
                  ><strong class="plan-status" :class="'plan-' + getPlan.status">{{ getPlan.status }}</strong></a
                >
              </p>
              <p>
                Cards remaining:
                <strong>{{ getPlan.remainingCards }}</strong>
              </p>
            </div>
            <img src="https://truelifeorg.s3.amazonaws.com/images/sealofapproval.png" style="width: 100%" />
          </a-collapse-panel>
        </a-collapse>
        <a-card :title="$t('cardTitle.churchTraningVideo')" v-if="!isFreeEvangelism">
          <div id="churchTrainingVideo"></div>
          <br />
          <a-icon type="video-camera" />&nbsp;{{ $t('page.dashboard.churchTraningVideo.para1') }}
          <br />
          <br />
          <a-button
            type="primary"
            @click="openLink('https://www.dropbox.com/scl/fi/p2mh7s3ewtixx6cvlq3c1/church_training_video_tl-1080p-1.mp4?rlkey=om5wv16a8miyf12uz111t1n13&st=e0x9x7d6&dl=1', true)"
          >
            <span> <a-icon type="download" />&nbsp;{{ $t('button.downloadTrainngVideo') }} </span>
          </a-button>
        </a-card>
        <a-card :title="$t('cardTitle.whyYouShouldUpgrade')" v-if="isFreeEvangelism">
          <div id="whyYouShouldUPgrade"></div>
          <br />
          <a-icon type="video-camera" />&nbsp;{{ $t('page.dashboard.whyYouShouldUpgrade.para1') }}
          <br />
          <br />
          <div style="text-align: left">
            <a-button type="primary" @click="goToUpgrade">
              <span>Upgrade</span>
            </a-button>
          </div>
        </a-card>
        <a-card :title="$t('cardTitle.videoShareWithChuch')">
          <div id="churchShareVideo"></div>
          <br />
          <a-icon type="video-camera" />&nbsp;{{ $t('page.dashboard.videoShareWithChuch.para1') }}
          <br />
          <br />
          <a-button
            type="primary"
            @click="openLink('https://www.dropbox.com/scl/fi/060ls6iduutbg00vwsxy1/Church-ShareTheTruthNOW.com-Introduction.mp4?rlkey=okvvcpk1mg3txvcg9xbl8uq62&st=24rzm52z&dl=1', true)"
          >
            <span> <a-icon type="download" />&nbsp;{{ $t('button.downloadTrainngVideo') }} </span>
          </a-button>
        </a-card>
        <a-card :title="$t('cardTitle.jesusStoryChurchPayingVideo')" v-if="!isFreeEvangelism">
          <div id="jesusStoryChurchPayingVideo"></div>
          <br />
          <a-icon type="video-camera" />&nbsp;{{ $t('page.dashboard.videoShareWithChuch.para1') }}
          <br />
          <br />
          <a-button type="primary" @click="openLink('https://s3.amazonaws.com/tl-welcome-video/Intro+Video+TL.mp4', true)">
            <span> <a-icon type="download" />&nbsp;{{ $t('button.downloadTrainngVideo') }} </span>
          </a-button>
        </a-card>
        <a-card :title="$t('cardTitle.getWeeklyResults')" v-if="false">
          <a-icon type="video-camera" />&nbsp;{{ $t('page.dashboard.getWeeklyResults.para1') }}
          <br />
          <br />
          <a-button type="primary" @click="openLink('getResults')">
            <span> <a-icon type="video-camera" />&nbsp;{{ $t('button.video') }} </span>
          </a-button>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { isEmpty, includes } from 'lodash';
import PaymentService from '@/services/PaymentService';
import PageService from '@/services/PageService';
import ActionBox from './ActionBox';
export default {
  data: () => ({
    dataInput: {},
    nextPayment: false,
    pageDescription: [],
    plans: [],
  }),
  components: {
    ActionBox,
  },
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
    isFreeEvangelism() {
      return includes(this.user.user.role, 'free_evangelism');
    },
    getPlan() {
      const membership = this.user.user.membership;
      if (membership && !isEmpty(this.plans)) {
        const plan = this.plans.find(p => p.plan_code === membership.plan_code);

        if (!plan) {
          return;
        }

        return {
          title: `${Number(plan.min_attendance).toLocaleString()} - ${Number(plan.max_attendance).toLocaleString()} (Attendance)`,
          subscription: `$${plan.price}/${plan.plan_type === 'yearly' ? 'Y' : 'MO'}`,
          status: membership.state,
          remainingCards: membership.active_cards,
        };
      }
      return null;
    },
  },
  methods: {
    openLink(url, isLink = false) {
      if (isLink) {
        window.open(url, '_blank');
      } else {
        this.$router.push({ name: url });
      }
    },
    goToUpgrade() {
      this.$router.push({ name: 'upgradeInformation' });
    },
  },
  async created() {
    // const respInvoice = await UserService.getInvoices();
    // const firstInvoiceDueOn = get(respInvoice, '[0].due_on');
    // if (!empty(firstInvoiceDueOn)) {
    //   this.nextPayment = moment(firstInvoiceDueOn).add('years', 1).format('MM/DD');
    // } else {
    //   this.nextPayment = false;
    // }
    if (this.isFreeEvangelism) {
      this.pageDescription = await PageService.getPageBy('dashboard-detail-for-free');
    } else {
      this.pageDescription = await PageService.getPageBy('dashboard-detail-for-pastors');
    }

    const plans = await PaymentService.getPlans();
    this.plans = plans;

    if (this.isFreeEvangelism) {
      const freePastorUPgradeVideo = this.instructionVideo('FREE_PASTOR_UPGRADE_VIDEO');
      if (freePastorUPgradeVideo) {
        window.jwplayer('whyYouShouldUPgrade').setup({
          file: freePastorUPgradeVideo,
          image: require('../../assets/images/upgrade.png'), // uploaded manually
          primary: 'flash',
          type: 'mp4',
          autostart: false,
          repeat: false,
        });
      }
    } else {
      const trainingVideo = this.instructionVideo('CHURCH_TRAINING');
      if (trainingVideo) {
        window.jwplayer('churchTrainingVideo').setup({
          file: trainingVideo,
          image: 'https://truelifeorg.s3.amazonaws.com/resources/church_training_thumb.png', // uploaded manually
          primary: 'flash',
          type: 'mp4',
          autostart: false,
          repeat: false,
        });
      }
      const churchPayingVideo = 'https://truelifeorg.s3.amazonaws.com/videos/Intro%2BVideo%2BTL.mp4';
      if (churchPayingVideo) {
        window.jwplayer('jesusStoryChurchPayingVideo').setup({
          file: churchPayingVideo,
          image: 'https://truelifeorg.s3.amazonaws.com/resources/church_share_thumb.png', // uploaded manually
          primary: 'flash',
          type: 'mp4',
          autostart: false,
          repeat: false,
        });
      }
    }

    const shareVideo = 'https://truelifeorg.s3.amazonaws.com/videos/1699371970606_STTN+for+Church.mp4';
    if (shareVideo) {
      window.jwplayer('churchShareVideo').setup({
        file: shareVideo,
        image: require('../../assets/images/instructionVideo.png'), // uploaded manually
        primary: 'flash',
        type: 'mp4',
        autostart: false,
        repeat: false,
      });
    }
  },
};
</script>
<style lang="scss">
.dashboard-container.content-page {
  padding: 0 !important;
  .dashboard {
    padding: 20px;
    .ant-btn {
      // height: 100%;
      white-space: initial;
    }

    .ant-collapse .ant-collapse-header {
      background: white !important;
      padding: 24px;
      font-size: 20px;

      & > i.ant-collapse-arrow {
        display: none !important;
      }
    }
  }

  .para-ordered {
    li {
      padding-left: 8px;
      padding-bottom: 8px;
    }
  }
}
</style>
<style lang="scss" scoped>
@media (max-width: 543px) {
  .dashboard-container.content-page {
    .quotes-wrapper {
      margin-bottom: -5rem !important;
    }
  }
}
</style>
